import { Guardian } from '@xaamin/guardian';

Guardian.define('hits.listar', (user) => {
  return user.can('hits.listar');
});